import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  activationCodeBtn: {
    borderRadius: '0 .25rem .25rem 0'
  },
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem',
    alignItems: 'center'
  },
  dFlex: {
    display: 'flex',
    flex: 0.6,
    inlineSize: '10.625rem',
    wordWrap: 'break-word',
    alignItems: 'center'
  },
  token: {
    whiteSpace: 'nowrap',
    width: '10.25rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '.5rem'
  },
  chartWrapper: {
    borderRadius: 4,
    border: '1px solid var(--mui-palette-divider)',
    '& .MuiCard-root': {
      boxShadow: 'none'
    },
    '& .MuiCardHeader-root': {
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem'
    },
    '& >div': {
      minHeight: 'auto!important',
      '& >div': {
        minHeight: 'auto!important'
      }
    }
  },
  chartHeaderBox: {
    padding: '.5rem 1rem'
  },
  chartContainer: {
    backgroundColor: 'var(--mui-palette-transparent-a5)'
  },
  chartContainerBox: {
    position: 'relative'
  },
  chartContainerMsg: {
    position: 'absolute',
    paddingLeft: '42%',
    paddingTop: '8%'
  },
  chartContainerMsgBox: {
    color: 'text.secondary',
    height: '6rem'
  }
}));

export default useStyles;
